import { Stack } from 'expo-router';

function PayLaterLayout() {
  return <Stack />;
}

export default PayLaterLayout;
